module.exports = "//public.zight.com/packs/media/images/added-to-collections-active-c950a0ed2bc71bf9be3511d4d0acf7d1.svg";